import { useState, useEffect, useCallback, useRef } from "react";

function Sidebar({ page, setPage, overdueCount, alertCount, pendingCount }) {
  const nav = [
    {
      id: "dashboard",
      icon: <i className="bi bi-speedometer2" />,
      label: "Dashboard",
      section: "OVERVIEW",
    },
   /* {
      id: "customers",
      icon: <i className="bi bi-people-fill" />,
      label: "Customers",
      section: "CORE",
    }, */
    {
      id: "orders",
      icon: <i className="bi bi-box-seam" />,
      label: "Orders",
      badge: pendingCount > 0 ? pendingCount : null,
      section: "CORE",
    },
    {
      id: "collection",
      icon: <i className="bi bi-wallet2" />,
      label: "Collection",
      badge: overdueCount > 0 ? overdueCount : null,
      section: "CORE",
    },
    {
      id: "reporting",
      icon: <i className="bi bi-bar-chart-line-fill" />,
      label: "Reporting",
      section: "ANALYTICS",
    },
    {
      id: "inventory",
      icon: <i className="bi bi-archive-fill" />,
      label: "Inventory",
      badge: alertCount > 0 ? alertCount : null,
      section: "OPERATIONS",
    },
    {
      id: "deliveries",
      icon: <i className="bi bi-truck" />,
      label: "Deliveries",
    },
  ];

  let lastSection = null;

  return (
    <div className="sb">
      <div className="sb-glow" />
      <div className="sb-brand">
        <div className="sb-logo">
          <i className="bi bi-fire" />
        </div>
        <div>
          <div className="sb-name">GasCRM Pro</div>
          <div className="sb-sub">Gas Provider Suite</div>
        </div>
      </div>
      <div className="sb-nav">
        {nav.map((item) => {
          const showSection = item.section && item.section !== lastSection;
          if (item.section) lastSection = item.section;
          return (
            <div key={item.id}>
              {showSection && <div className="sb-section">{item.section}</div>}
              <div
                className={`nav ${page === item.id ? "on" : ""}`}
                onClick={() => setPage(item.id)}
              >
                <span className="nav-ico">{item.icon}</span>
                <span className="nav-lbl">{item.label}</span>
                {item.badge && <span className="nav-badge">{item.badge}</span>}
              </div>
            </div>
          );
        })}
      </div>
      <div className="sb-footer">
        <div className="sb-user">
          <div className="sb-avatar">AM</div>
          <div>
            <div className="sb-uname">Alex Morgan</div>
            <div className="sb-urole">Operations Manager</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
